import { render, staticRenderFns } from "./HtmlLink.vue?vue&type=template&id=3f8f5643&functional=true&"
import script from "./HtmlLink.vue?vue&type=script&lang=js&"
export * from "./HtmlLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports